var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsSortBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.059,
    height: 13.996,
    viewBox: "0 0 10.059 13.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-9.809-5.625a.845.845,0,0,0-.6,1.441L-6.219,0A.84.84,0,0,0-5.027,0L-.844-4.184a.845.845,0,0,0-.6-1.441ZM-.844-9.316-5.027-13.5a.84.84,0,0,0-1.192,0l-4.187,4.184a.845.845,0,0,0,.6,1.441h8.367A.845.845,0,0,0-.844-9.316Z",
    transform: "translate(10.655 13.748)",
    fill: "#3a3630",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSortBy);
export default __webpack_public_path__ + "static/media/icons_SortBy.86cfba2f.svg";
export { ForwardRef as ReactComponent };